import React from 'react'
import styled from '@emotion/styled'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLock } from '@fortawesome/pro-regular-svg-icons/faLock'
import { faLockOpen } from '@fortawesome/pro-regular-svg-icons/faLockOpen'

const LockWrapper = styled.div`
    margin: 0 10px 0.5rem;
    flex-grow: 1;

    button {
        height: 30px;
        width: 38px;
        padding: 0;
        border-color: transparent;
        background-color: #666;
        color: #c0c0c0;
    }
`

const Lock = ({ locked, onClick }) => (
    <LockWrapper>
        <button className="btn btn-light" onClick={onClick}>
            <FontAwesomeIcon icon={locked ? faLock : faLockOpen} size="xs" />
        </button>
    </LockWrapper>
)

export default Lock
